<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span class="tt-grid-booking__title-content">
        <span>{{ page?.heading || "" }}</span>
        <span class="tt-grid-booking__title-actions">
            <tt-overflow-menu class="tt-grid-booking__overflow-menu">
                <tt-overflow-menu-item ttIcon="fal fa-undo" ttText="state_modal_reset_size" (ttClick)="resetSize()"></tt-overflow-menu-item>
            </tt-overflow-menu>
            <button class="tt-grid-booking__close" type="button" aria-label="Close" (click)="dismiss()"><span class="far fa-times"></span></button>
        </span>
    </span>
</h2>

<mat-dialog-content>
    <div class="col-xs-12 sp-0" style="position: sticky; top: 0; left: 0; z-index: 12333; background-color: var(--tt-modal--color); padding-top: 15px">
        <div class="col-xs-8 sp-8">
            <div class="col-xs-12 sp-0" style="display: flex; align-items: flex-end; gap: 5px">
                <tt-date class="col-xs-2 sp-0" ttLabel="voucherdate" [(ttModel)]="voucher.voucherdate" (ttModelChange)="onVoucherDateChanged($event)" [ttAllowEmpty]="false"></tt-date>
                <tt-date class="col-xs-2 sp-0" ttLabel="transdate" [(ttModel)]="voucher.transdate" [ttAllowEmpty]="false"></tt-date>
                <tt-button class="col-xs-3 sp-0" ttText="update_dates_to_rows" (ttClick)="overrideDatesToRows()"></tt-button>
            </div>

            <tt-textarea class="col-xs-12 sp-2" ttLabel="note" ttLabelView="top" [(ttModel)]="voucher.note"></tt-textarea>
        </div>

        <tt-file-uploader class="col-xs-4 sp-8" ttLabel="attachment" ttLabelView="top" ttDropZone [(ttFiles)]="files" ttMultiple></tt-file-uploader>

        <hr class="k-hr" />

        <div class="col-xs-11 sp-0" style="display: flex; align-items: flex-end">
            <tt-input class="col-xs-1 sp-2" ttLabel="accountingprocessing_sum_dbcr" ttTextAlign="right" [ttModel]="voucher.amount" ttReadonly></tt-input>

            <tt-input class="col-xs-1 sp-2" ttLabel="amount_vat" ttTextAlign="right" [ttModel]="voucher.amount_vat" ttReadonly></tt-input>
        </div>
    </div>

    <tt-grid class="col-xs-12 sp-0" *ngIf="ready && !!grid" [ttOptions]="grid" (ttRowDataChange)="onRowChanged($event)" (ttReady)="onGridReady()"></tt-grid>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <tt-button class="col-xs-2 sp-2 pull-right" ttText="create_acvoucher" ttType="success" (ttClick)="createAcVoucher()" [ttLoading]="creatingVoucher" [ttDisabled]="posting"></tt-button>

    <tt-button
        class="col-xs-2 sp-2 pull-right"
        [ttText]="page?.label_bookkeep || 'accountingprocessing_bookkeep'"
        [ttTranslateText]="!page?.label_bookkeep"
        ttType="primary"
        (ttClick)="bookkeep()"
        [ttLoading]="posting"
        [ttDisabled]="creatingVoucher"
    ></tt-button>
</mat-dialog-actions>

<button class="tt-grid-booking__resize-handle" type="button" aria-label="Resize modal" title="Resize modal" (pointerdown)="startResize($event)" (keydown)="resizeWithKeyboard($event)"></button>
